import { Component, EventEmitter, Input, Output } from "@angular/core";
import { GridPagingOptions } from "../grid-query.model";

/**
 * Nest this inside of the kno2-grid component for the option to change the page size:
 * <kno2-grid>
        <kno2-grid-page-size-select (pageSizeChange)="onPageChange($event)"></kno2-grid-page-size-select>
 * <kno2-grid>
 */
@Component({
    selector: "kno2-grid-page-size-select",
    template: `
        <nb-select
            [selected]="options[0]"
            (selectedChange)="onSelectedChange($event)"
            size="small"
            class="mr-1 page-size-select">
            @for (option of options; track option) {
                <nb-option [value]="option">
                    {{ option }}
                </nb-option>
            }
        </nb-select>
        records per page
    `,
    styleUrls: ["./grid-page-size-select.component.scss"],
    standalone: false
})
export class GridPageSizeSelectComponent {
    @Input() public options: Array<number> = [10, 25, 50];
    @Output() public pageSizeChange: EventEmitter<GridPagingOptions>;

    constructor() {
        this.pageSizeChange = new EventEmitter<GridPagingOptions>();
    }

    public onSelectedChange(pageSize: number): void {
        this.pageSizeChange.emit({ pageNumber: 1, pageSize });
    }
}
